import { Paragraph, Text } from '@zillow/constellation-10';

type StatementEntryProps = {
  text: string;
  emphasize: boolean | null;
  danger: boolean | null;
};

type Props = {
  statement: Array<StatementEntryProps>;
};

const StatementEntry = ({ text, emphasize, danger }: StatementEntryProps) => (
  <Text
    {...(emphasize && { textStyle: 'body-bold' as const })}
    {...(danger && { css: { color: 'token(colors.text.danger)' } })}
  >
    {text}
  </Text>
);

export const DashboardSubheading = ({ statement }: Props) => (
  <Paragraph css={{ marginTop: 'tighter' }}>
    {statement.map((props, index) => (
      <StatementEntry key={index} {...props} />
    ))}
  </Paragraph>
);
